export enum GENDER {
	MALE = 'male',
	FEMALE = 'female',
}

export enum FOCUS_AREA {
	LEGS_GLUTES = 'legs_glutes',
	ARM_BACK = 'arm_back',
	ABS_CORE = 'abs_core',
}

export enum GOAL {
	LOSE_WEIGHT = 'lose_weight',
	BODY_TONE_UP = 'body_tone_up',
	LOVE_MYSELF = 'love_myself',
	GAIN_MUSCLES = 'gain_muscles',
	GAIN_MUSCLES_FEMALE = 'gain_muscles_female',
	GAIN_FLEXIBILITY = 'gain_flexibility',
	GAIN_BUILD_ENDURANCE = 'gain_build_endurance',
	GAIN_HEALTHIER_LIFE = 'gain_healthier_life',
}

export enum DIET_TYPE {
	ALL = 'all',
	VEGETARIAN = 'vegetarian',
	VEGAN = 'vegan',
	KETO = 'keto',
}

export enum BODY_TYPE {
	APPLE = 'apple',
	PEAR = 'pear',
	SQUARE = 'square',
	TRAPEZOID = 'trapezoid',
	HOURGLASS = 'hourglass',
	TRIANGLE = 'triangle',
	UNKNOWN = 'unknown',
}

export enum EXERCISES_TIME {
	MORNING = 'morning',
	DAY = 'day',
	EVENING = 'evening',
	NOT_SURE = 'not_sure',
}

export enum FREQUENCY {
	MINIMUM = 'minimum',
	NORMAL = 'normal',
	MAXIMUM = 'maximum',
}

export enum DURATION {
	MINIMUM = 'minimum',
	NORMAL = 'normal',
	MAXIMUM = 'maximum',
	UNDEFINED = 'undefined',
}

export enum AGE {
	VERY_YOUNG = '18-29',
	YOUNG = '30-39',
	NORMAL = '40-49',
	OLD = '50-59+',
}

export enum UPGRADE_LIFETIME_VERSION {
	V1 = 'V1',
}

export enum UPSALE_PDF {
	V1 = 'V1',
}
